import React from 'react';
import styled from 'styled-components';
import * as bp from 'view/styles/breakpoints';
import * as grid from 'view/styles/grid';
import { TopicsList as StyledList } from 'view/styles/help-center';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { LoadingSkeleton } from '@atlassian/help-center-common-component/loading';

// eslint-disable-next-line rulesdir/no-styled-export, rulesdir/styled-component-order
export const LoaderShell = styled.div`
    display: flex;
`;

export const Loader = ({ height = 10 }) => (
    <LoadingSkeleton backgroundColor={token('color.skeleton', colors.N30)} height={height} />
);

// eslint-disable-next-line rulesdir/no-styled-export
export const Topics = styled(StyledList)<{ count: number }>`
    ${bp.fromMedium.css`
    & > li {
        flex-basis: ${({ count }) => {
            if (count > 2) {
                return '33%';
            }
            if (count === 2) {
                return '50%';
            }
            return '100%';
        }};
    };`}
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const HelpObjects = styled.ol`
    padding: ${token('space.0', '0px')};
    list-style-type: none;
    display: flex;
    flex-direction: column;
    width: 100%;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Topic = styled.li`
    padding: ${token('space.200', '16px')};
    box-sizing: border-box;
    margin-top: ${token('space.0', '0px')};
    & ${HelpObjects} {
        margin: 0 0 ${token('space.400', '32px')};
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const HelpObject = styled.li`
    display: flex;
    margin-top: ${token('space.200', '16px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Icon = styled.div`
    width: ${grid.multiple(3).px};
    height: ${grid.multiple(3).px};
    margin-right: ${token('space.100', '8px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const HelpObjectLink = styled.div`
    width: 60%;
`;
